export default __webpack_public_path__ + "static/media/setup.3c560f8d.svg";